module.exports = __webpack_public_path__ + "img/638.b65a63ef.gif";